import { updateReshipmentItem } from '../../actions/reshipment'
import { getReshipmentSummaryData } from '../../selectors/reshipment'

const mapStateToProps = (state, ownProps) => {
  const {
    item: { name, description = '', quantity, ancillaryCd },
  } = ownProps
  const { orgId } = getReshipmentSummaryData(state)

  return {
    orgId,
    name,
    description,
    quantity,
    ancillaryCd,
  }
}

export default connect(mapStateToProps, { updateReshipmentItem })(
  ({ orgId, name, description, quantity, ancillaryCd, updateReshipmentItem }) => {
    return (
      <div
        style={{
          marginTop: '8px',
          border: '1px solid #ccc',
          backgroundColor: '#fff',
          padding: '8px',
        }}
      >
        <div style={{ fontWeight: 'bold' }}>{name}</div>
        {description && <div>{description}</div>}
        <div style={{ display: 'flex' }}>
          <div>Qty: {quantity}</div>
          <button
            type="button"
            className="btn-link cb-small-font-size"
            style={{ marginLeft: 'auto', color: 'red' }}
            onClick={() => updateReshipmentItem(orgId, { ancillaryCd, quantity: 0 })}
          >
            <span className="cb-glyph cb-minus" /> Remove
          </button>
        </div>
      </div>
    )
  }
)
